import { BaseFormatEvent } from '../base-format-event.model';

export class PreloadedEvent extends BaseFormatEvent {
  constructor() {
    super('preloaded');
  }
}
